<template>
  <div>
    <a-modal
      :afterClose="onClose"
      :title="null"
      :closable="false"
      :footer="null"
      width="765px"
      v-model="evaluateThis"
    >
      <div class="evaluateThis">
        <div class="type-box">
          <div class="type-title hp_center">评价医生</div>
          <div class="doctor-info">
            <div class="doctor-img">
              <img src="@/assets/default-img/r-doctor.png" alt />
            </div>
            <div class="info-box">
              <div>
                <span style="font-size: 26px;">{{ dataForm.doctorName }}</span>
                <span>{{ dataForm.deptName }}</span>
              </div>
              <div>
                <span>{{ dataForm.hospitalName }}</span>
              </div>
            </div>
          </div>
          <div style="padding-left:15px">
            <a-form-model
              layout="horizontal"
              :model="doctorForm"
              :rules="rules"
            >
              <a-form-model-item
                label="问诊满意度："
                :labelCol="{ span: 4 }"
                prop="value"
              >
                <a-rate allow-half v-model="doctorForm.value" />
              </a-form-model-item>
              <a-form-model-item
                :labelCol="{ span: 5 }"
                label="对医生的印象："
                prop="value1"
              >
                <a-checkbox-group
                  v-model="doctorForm.value1"
                  name="checkboxgroup"
                  :options="doctorDict"
                />
              </a-form-model-item>
              <a-form-model-item label="给医生说点什么吧："></a-form-model-item>
              <a-form-model-item prop="desc">
                <a-input
                  v-model="doctorForm.desc"
                  placeholder="问诊过程还满意吗？说说您的感受和建议吧！"
                  type="textarea"
                  autoSize
                  showCount
                  style="height:210px; font-size: 22px; font-family: Source Han Sans CN; font-weight: 400; "
                  :maxLength="150"
                />
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>

        <div class="type-box">
          <div class="type-title hp_center">评价医院</div>
          <div class="doctor-info">
            <div class="doctor-img">
              <img src="@/assets/default-img/r-doctor.png" alt />
            </div>
            <div class="info-box">
              <div>
                <span style="font-size: 26px;">{{
                  dataForm.hospitalName
                }}</span>
              </div>
            </div>
          </div>
          <div style="padding-left:15px">
            <a-form-model
              layout="horizontal"
              :model="hospitalForm"
              :rules="rules"
            >
              <a-form-model-item
                label="问诊满意度："
                :labelCol="{ span: 4 }"
                prop="value"
              >
                <a-rate allow-half v-model="hospitalForm.value" />
              </a-form-model-item>
              <a-form-model-item
                :labelCol="{ span: 5 }"
                label="对医院的印象："
                prop="value1"
              >
                <a-checkbox-group
                  v-model="hospitalForm.value1"
                  name="checkboxgroup"
                  :options="hosDict"
                />
              </a-form-model-item>
              <a-form-model-item label="给医院说点什么吧："></a-form-model-item>
              <a-form-model-item prop="desc">
                <a-input
                  v-model="hospitalForm.desc"
                  placeholder="问诊过程还满意吗？说说您的感受和建议吧！"
                  type="textarea"
                  autoSize
                  showCount
                  style="height:210px; font-size: 22px; font-family: Source Han Sans CN; font-weight: 400; "
                  :maxLength="150"
                />
              </a-form-model-item>
              <div @click="sumbit" class="btn hp_center cursor-point">提交</div>
            </a-form-model>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { getDict, submitReservedComment } from '@/api/registered'
import { ls } from '@/utils/tool'
export default {
  props: ['dataForm'],
  data() {
    return {
      sysUser: ls.get('sysUser'),
      doctorDict: [],
      hosDict: [],
      evaluateThis: false,
      doctorForm: {},
      hospitalForm: {},
      rules: {
        name: [
          {
            required: true,
            message: 'Please input Activity name',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 5,
            message: 'Length should be 3 to 5',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    dataForm(val) {
      console.log('this.dataForm======', this.dataForm)
    },
  },
  mounted() {
    this.initDict()
  },
  methods: {
    async sumbit() {
      console.log('this.dataForm======', this.dataForm)
      console.log('this.doctorForm======', this.doctorForm)
      console.log('this.hospitalForm======', this.hospitalForm)
      if (!this.doctorForm.value) {
        this.$message.error('请选择医生评分')
        return
      }
      if (!this.doctorForm.desc) {
        this.$message.error('请填写医生评价内容')
        return
      }
      if (!this.doctorForm.value) {
        this.$message.error('请选择择医院评分')
        return
      }
      if (!this.doctorForm.desc) {
        this.$message.error('请填写择医院评价内容')
        return
      }
      let value1 = [...this.doctorForm.value1, this.doctorForm.desc]
      let content1 = value1.join('|||这是分割标志|||')
      let obj1 = {}
      obj1.content = content1
      obj1.hisDoctorId = this.dataForm.hisDoctorId
      obj1.memberId = this.sysUser.id
      obj1.objTime = this.dataForm.objTime
      obj1.objType = 2
      obj1.recordId = this.dataForm.recordId
      obj1.star = this.doctorForm.value*2
      obj1.visitId = this.dataForm.visitId
      obj1.hospitalId = this.dataForm.hospitalId
      
      let value2 = [...this.hospitalForm.value1, this.hospitalForm.desc]
      let content2 = value2.join('|||这是分割标志|||')
      let obj2 = {}
      obj2.content = content2
      obj2.hisDoctorId = this.dataForm.hisDoctorId
      obj2.memberId = this.sysUser.id
      obj2.objId = this.dataForm.hospitalId
      obj2.objTime = this.dataForm.objTime
      obj2.objType = 1
      obj2.recordId = this.dataForm.recordId
      obj2.star = this.doctorForm.value*2
      obj2.visitId = this.dataForm.visitId
      obj2.hospitalId = this.dataForm.hospitalId
      let resp = [obj1, obj2]
      var res = await submitReservedComment(resp)
      this.onClose()
      console.log('res=========', res)
    },
    async initDict() {
      var list = [
        {
          type: 'DOCTOR_IMPRESSION',
        },
        {
          type: 'HOSP_IMPRESSION',
        },
      ]
      list.map(async (item) => {
        var res = await getDict(item)

        if (item.type == 'DOCTOR_IMPRESSION') {
          this.doctorDict = res.data || []
          this.doctorDict = this.doctorDict.map((item) => {
            return item.text
          })
          console.log('this.doctorDict===', this.doctorDict)
        }
        if (item.type == 'HOSP_IMPRESSION') {
          this.hosDict = res.data || []
          this.hosDict = this.hosDict.map((item) => {
            return item.text
          })
        }
      })
    },
    strSplit(str, dict, num) {
      var arr = str.split('|||')
      var content = ''
      arr = arr.filter((item) => {
        var save = dict.some((d) => {
          return d.text == item
        })
        if (save) {
          return item
        } else {
          content = item
        }
      })
      return !num ? arr || [] : content
    },
    onClose() {
      this.doctorForm = {}
      this.hospitalForm = {}
      this.evaluateThis = false
    },
    onShow() {
      this.evaluateThis = true
    },
  },
}
</script>
<style lang="less" scoped>
.evaluateThis {
  width: 100%;
  padding: 0 25px 30px;
  .type-box {
    padding-top: 15px;
    position: relative;
    .type-title {
      width: 140px;
      height: 51px;
      background: #c4e5fe;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #459df7;
      position: absolute;
      top: 0;
      right: 0;
    }
    .doctor-info {
      display: flex;
      padding: 0 13px;
      padding-bottom: 7px;
      border-bottom: 1px solid #e1e1e1;
      margin-bottom: 20px;
      .doctor-img {
        width: 77px;
        height: 77px;
        margin-right: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info-box {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        div {
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          span {
            margin-right: 25px;
          }
        }
      }
    }
    .btn {
      width: 100%;
      height: 74px;
      background: #459df7;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #f6f6f6;
    }
  }
}
/deep/ .ant-modal-content {
  border-radius: 32px;
}
/deep/ .ant-modal-body {
  padding: 0;
}
/deep/ .ant-form {
  .ant-form-item-label {
    margin-right: 20px;
  }
  .ant-form-item-label > label {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
  }
  .ant-rate-star {
    i {
      font-size: 28px;
    }
  }
}
/deep/ .ant-checkbox-group {
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;

  .ant-checkbox-group-item {
    padding: 10px 18px;
    border: 1px solid #459df7;
    border-radius: 5px;
    margin-bottom: 15px;
    color: #459df7;
    .ant-checkbox {
      .ant-checkbox-input {
        width: 0;
        height: 0;
      }
      .ant-checkbox-inner {
        width: 0;
        height: 0;
        border: none;
      }
    }
    .ant-checkbox-checked::after {
      border: none;
      opacity: 0;
    }
  }
  .ant-checkbox-wrapper-checked {
    background: #459df7;
    color: #fff;

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border: none;
      opacity: 0;
    }
  }
}
</style>
